import AxiosManager from "../_axiosManager";

export async function postParkConsultingComplete(ids: number[]) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/parkconsulting/complete/status",
    { ids },
  );

  return res;
}

export async function putParkConsultingComplete({
  parkConsultingId,
  body,
}: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/parkconsulting/${parkConsultingId}`,
    body,
  );

  return res;
}

export async function postAskGraveMoveComplete(ids: number[]) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/askgravemove/complete/status",
    { ids },
  );

  return res;
}

export async function putAskGraveMove({ askGraveMoveId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/askgravemove/${askGraveMoveId}`,
    body,
  );

  return res;
}

export async function postGraveComplete(ids: number[]) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/cemetery-consulting/complete/status",
    { ids },
  );

  return res;
}

export async function putGrave({ graveId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/cemetery-consulting/${graveId}`,
    body,
  );

  return res;
}

export async function postFuneralComplete(ids: number[]) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/funeral-consulting/complete/status",
    { ids },
  );

  return res;
}

export async function putFuneral({ funeralId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/funeral-consulting/${funeralId}`,
    body,
  );

  return res;
}

export async function postInheritanceComplete(ids: number[]) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/inherit-consulting/complete/status",
    { ids },
  );

  return res;
}

export async function putInheritance({ inheritanceId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/inherit-consulting/${inheritanceId}`,
    body,
  );

  return res;
}

export async function postMemoryComplete(ids: number[]) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/left-goods-consulting/complete/status",
    { ids },
  );

  return res;
}

export async function putMemory({ memoryId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/left-goods-consulting/${memoryId}`,
    body,
  );

  return res;
}
